<template>
  <div class="wrap">
    <div class="bottomTop">
      <div class="wrapW">
        <div class="left">
          <img :src="list.logo" class="logo1">
          <div class="shuxian"></div>
          <div class="left_r">
            <p>官方其他业务</p>
            <a :href="i.url" v-for="(i,index) in list.other" :key="index">
              <img :src="i.img">
            </a>
          </div>
        </div>
        <div class="center" v-if="list.qrcode_status === 1">
          <div class="ma">
            <div class="maD" v-for="(i,index) in list.qrcode" :key="index">
              <img :src="i.img">
              <div>{{i.name}}</div>
            </div>
          </div>
        </div>
        <div class="right">
          <div>
            <p>24小时服务热线：{{list.hotline}}</p>
            <p>地址：{{list.address}}</p>
          </div>
          <div>
            <p>西北运营中心：{{list.xname}}</p>
            <p>西北运营中心电话：{{list.xline}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomB">
      <ul class="wrapW">
        <li v-for="(i, index) in list.entrance" :key="index"><a :href="i.url">{{i.name}}</a></li>
      </ul>
      <div class="copyright wrapW">{{list.copyright}} {{list.record}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Bottom',
  data () {
    return {
      list: []
    }
  },
  mounted () {
    this.getBottom()
  },
  methods: {
    getBottom () {
      let that = this
      this.$axios.get(process.env.API_HOSTT + '/os/getBottom', {
      }).then(
        function (res) {
          res = res.data.data
          that.list = res
        }
      ).catch(error => console.log(error))
    }
  }
}
</script>
<style lang="stylus" scoped>
.wrap
  width 100%
  z-index 999
  background #323232
  .bottomTop
    display flex
    width 100%
    background #323232
    padding .52rem 0
    .wrapW
      display flex
      justify-content space-between
      align-items center
    .left
      display flex
      .left_r
        display flex
        flex-flow row wrap
        a
          width auto
          height auto
        img
          height .37rem
          margin-top .19rem
          margin-right .19rem
        p
          width 100%
          color #fff
          font-size 14px
          line-height .12rem
      .shuxian
        width 1px
        height .68rem
        background #585858
        margin 0 .22rem
      .logo1
        height .54rem
    .center
      .ma
        display flex
        .maD
          margin-right .6rem
          text-align center
          img
            height .8rem
            margin-bottom .2rem
          div
            color #939393
            font-size .16rem
    .right
      font-size .16rem
      color #939393
      div
        margin-bottom .22rem
      p
        line-height .25rem
  .bottomB
    width 100%
    background #212121
    text-align center
    padding .22rem 0
    ul
      display flex
      justify-content center
      font-size .14rem
      color #939393
      li
        margin 0 .15rem
    .copyright
      font-size .14rem
      color #939393
      line-height .13rem
      margin-top .22rem
    // .bottomL
    //   img
    //     width 1.5rem
    //   .www
    //     font-size .2rem
    //     font-weight 400
    //     color var(--indexColor)
    //     font-style italic
    //     margin-top .11rem
    // .bottomN
    //   display flex
    //   .bottomNU
    //     .title
    //       font-size .18rem
    //       color #fff
    //       margin-bottom .22rem
    //       text-align left
    //       font-weight 500
    //     ul
    //       width 100%
    //       li
    //         margin-bottom .09rem
    //         color #AFAFAF
    //         font-size .14rem
    // .bottomInfo
    //   color #fff
    //   font-size .16rem
    //   .name
    //     font-size .24rem
    //     margin-bottom .12rem
    //   .phoneT
    //     margin-bottom .08rem
    //   .phone
    //     font-size .3rem
    //     color var(--indexColor)
    //     font-style italic
    //     margin-bottom .15rem
    //     font-weight bold
    //   .details
    //     font-size .18rem
    //     line-height .30rem
    //     margin-bottom .3rem
    //   .ma
    //     display flex
    //     .maD
    //       width .9rem
    //       margin-right .3rem
    //       img
    //         width 100%
    //       div
    //         font-size .16rem
    //         color #fff
    //         margin-top .2rem
    //         text-align center
    // .copyright
    //   width 100%
    //   height .4rem
    //   line-height .4rem
    //   border-top 1px solid #444
    //   color #999999
    //   font-size .12rem
    //   text-align center
    //   margin-top .5rem
</style>



// WEBPACK FOOTER //
// src/components/Bottom.vue